var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShapeticket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 15 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 1.9C2.25 1.81716 2.31716 1.75 2.4 1.75H5.25947C5.38713 3.42811 6.78919 4.75 8.5 4.75C10.2108 4.75 11.6129 3.42811 11.7405 1.75H14.6C14.6828 1.75 14.75 1.81716 14.75 1.9V20.1C14.75 20.1828 14.6828 20.25 14.6 20.25H11.7405C11.6129 18.5719 10.2108 17.25 8.5 17.25C6.78919 17.25 5.38713 18.5719 5.25947 20.25H2.4C2.31716 20.25 2.25 20.1828 2.25 20.1V1.9ZM2.4 0.25C1.48873 0.25 0.75 0.988728 0.75 1.9V20.1C0.75 21.0113 1.48873 21.75 2.4 21.75H5.8C6.32467 21.75 6.75 21.3247 6.75 20.8V20.5C6.75 19.5335 7.5335 18.75 8.5 18.75C9.4665 18.75 10.25 19.5335 10.25 20.5V20.8C10.25 21.3247 10.6753 21.75 11.2 21.75H14.6C15.5113 21.75 16.25 21.0113 16.25 20.1V1.9C16.25 0.98873 15.5113 0.25 14.6 0.25H11.2C10.6753 0.25 10.25 0.675329 10.25 1.2V1.5C10.25 2.4665 9.4665 3.25 8.5 3.25C7.5335 3.25 6.75 2.4665 6.75 1.5V1.2C6.75 0.675331 6.32467 0.25 5.8 0.25H2.4ZM5 10.25C4.58579 10.25 4.25 10.5858 4.25 11C4.25 11.4142 4.58579 11.75 5 11.75H12C12.4142 11.75 12.75 11.4142 12.75 11C12.75 10.5858 12.4142 10.25 12 10.25H5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeticket);
export default __webpack_public_path__ + "static/media/Shapeticket.79ebf996de5d8990692d585087c2fa7b.svg";
export { ForwardRef as ReactComponent };